import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface CloseButtonProps {
  color?: string;
  onClose: () => void;
}

const CloseButton = ({ color, onClose }: CloseButtonProps) => (
  <IconButton
    aria-label="close"
    onClick={onClose}
    sx={(theme) => ({
      position: 'absolute',
      right: 8,
      top: 12,
      color: color ?? theme.palette.grey[500],
    })}
  >
    <CloseIcon />
  </IconButton>
);

export default CloseButton;
